<div class="logo-container">
  <img alt="" class="cc-logo" src="./assets/images/cc_logo.png">
  <h1 class="cc-text">{{getString('cheapcharts')}}</h1>
</div>

<div class="down-text">
  {{getMessage()}}
</div>